import React, { ReactNode } from 'react';
import classNames from 'classnames/bind';
import { Divider } from '@creditsights/styleguide-web';
import styles from './ScoreCharts.module.scss';

const cx = classNames.bind(styles);

interface ScoreChartsProps {
  leftSide: ReactNode | null;
  rightSide: ReactNode | null;
}

const ScoreCharts = ({ leftSide, rightSide }: ScoreChartsProps): React.ReactElement => {
  return (
    <div className={cx('body')}>
      {leftSide && (
        <div className={cx('item', 'left-item')} data-testid="left-side">
          {leftSide}
        </div>
      )}
      {rightSide && (
        <div className={cx('item', 'right-item')} data-testid="right-side">
          {leftSide && <Divider className={cx('divider')} vertical />}
          {rightSide}
        </div>
      )}
    </div>
  );
};

export default ScoreCharts;
